import callAPiBase from './base';

const schemasApi = {
  list: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/schemaList',
      method: 'GET',
      useToken: true,
      title: 'Schema - Get List',
      params,
    }),
};

export { schemasApi };
export default schemasApi;
